import { Config } from 'final-form'
import { Component } from 'vue-property-decorator'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { Field, Form } from '@skinsoft/ui'

export interface Values {
    motive: string;
    title: string;
}

@Component({
    props: ['onSubmit', 'initialValues', 'motives'],
    template: require('./create-movement-form.html'),
})
export class CreateMovementForm extends ReactiveVue {
    public onSubmit: Config['onSubmit'];
    public locations: Array<{ id: string; value: string; text: string }>;
    public initialValues: Values;
    public motives: ThesaurusTerm[];

    public $refs: {
        form: Form;
        location: Field;
    };

    public motivesToOptions() {
        return this.motives.map(term => {
            const translatedString = getTranslatedString(
                thesaurusTermSelectors.preferredTerm(term),
                this.getAppLocale()
            )

            return {
                text: this.$te(translatedString) ? this.$t(translatedString) : translatedString,
                value: term.id,
            };
        });
    }

    public async validate(values): Promise<object> {
        // need to be a promise to avoid conflict with $t mixin
        const errors = {} as any;

        if (!values.title) {
            errors.title = this.$t('movement.createModal.form.titleMissing');
        }

        return errors;
    }
}
